import { render, staticRenderFns } from "./RegisterByEmail.vue?vue&type=template&id=2fcd912e&scoped=true"
import script from "./RegisterByEmail.vue?vue&type=script&lang=js"
export * from "./RegisterByEmail.vue?vue&type=script&lang=js"
import style0 from "./RegisterByEmail.vue?vue&type=style&index=0&id=2fcd912e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd912e",
  null
  
)

export default component.exports